import { css, sva } from "../../../../styled-system/css";

export const inputClassNames = sva({
  slots: ["fieldWrapper", "label", "inputBox", "input", "error"],
  base: {
    fieldWrapper: {
      display: "flex",
      flex: "1",
      gap: "xsmall",
      flexDirection: "column",
      minWidth: "20px",
      "&[data-invalid] label": {
        color: "error",
      },
    },
    label: {
      display: "flex",
      gap: "xsmall",
      color: "text.label",
      fontSize: "medium",
      fontWeight: "bold",
      flexWrap: "nowrap",
    },
    inputBox: {
      display: "flex",
      gap: "small",
      alignItems: "center",
      alignSelf: "stretch",
      border: "input",
      borderRadius: "input",
      width: "100%",
      paddingX: "medium",

      color: "text.input",
      backgroundColor: "white",
      boxShadow: "none",

      _disabled: {
        cursor: "not-allowed",
        backgroundColor: "lightgrey",
      },
      "&[data-invalid]": {
        borderColor: "error",
      },

      "&:focus-within": {
        borderColor: "border.inputFocused",
      },
    },
    input: {
      flex: "1",
      border: "none",
      outline: "none",
      minWidth: 0,
      paddingY: "small",
      paddingX: "0",
      color: "text.input",
      fontSize: "medium",
      backgroundColor: "transparent",
      _disabled: {
        cursor: "not-allowed",
      },
      _focus: {
        color: "text.inputFocused",
      },
    },
    error: {
      color: "error",
      fontSize: "small",
      textAlign: "start",
    },
  },
  variants: {
    variant: {
      inline: {
        inputBox: {
          gap: "xsmall",
          border: "none",
          borderBottom: "input",
          borderRadius: "none",
          paddingX: "xsmall",
        },
        input: {
          paddingY: "0",
        },
      },
    },
    override: {
      textarea: {
        inputBox: {
          borderRadius: "1rem",
          paddingRight: "3px",
          paddingBottom: "3px",
        },
      },
    },
  },
});

export const popoverStyles = css({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  border: "1px solid {colors.grey}",
  outline: "none",
  borderRadius: "standard",
  backgroundColor: "white",
});
